import UAParser from 'ua-parser-js';

const { type } = new UAParser().getDevice();
const storageIsAvailable = !!(window.localStorage) && !(type === 'mobile' || type === 'tablet');

const keyNamespace = 'tele_';

const storage = window.localStorage;

export default {
  get: (key, defaultValue) => {
    if (!storageIsAvailable) {
      return defaultValue;
    }
    const storedValue = storage.getItem(`${keyNamespace}${key}`);
    if (storedValue !== null) {
      return JSON.parse(storedValue);
    }
    return defaultValue;
  },
  set: (key, value) => {
    if (!storageIsAvailable) {
      return;
    }
    storage.setItem(`${keyNamespace}${key}`, JSON.stringify(value));
  },
  clear: (key) => {
    if (!storageIsAvailable) {
      return;
    }
    storage.removeItem(`${keyNamespace}${key}`);
  },
  clearAll: () => {
    if (!storageIsAvailable) {
      return;
    }
    const keys = Object.keys(storage);
    keys.forEach((key) => {
      if (key.indexOf(keyNamespace) === 0) {
        storage.removeItem(key);
      }
    });
  },
};
